module.exports = __webpack_public_path__ + "static/media/Add.3a2ad90c.svg";